import { onPageLoad } from "helpers";

// Wait for the DOM to be fully loaded
onPageLoad(() => {
  // Get all forms with a non-empty data-confirm attribute
  const forms =
    document.querySelectorAll<HTMLFormElement>("form[data-confirm]");

  forms.forEach((form) => {
    const confirmMessage = form.getAttribute("data-confirm");

    if (confirmMessage && confirmMessage.trim().length > 0) {
      form.addEventListener("submit", (event) => {
        const confirmed = window.confirm(confirmMessage);
        if (!confirmed) {
          event.preventDefault();
        }
      });
    }
  });
});
